<template>
  <v-textarea
    v-model="currentValue"
    v-show="!hiddenField(access)"
    autocomplete="off"
    auto-grow
    :id="id"
    :label="label"
    :type="fieldTextType(dataType)"
    :required="requiredField(access)"
    :readonly="readonlyField(access)"
    :prefix="prefix"
    :suffix="suffix"
    :filled="readonlyField(access) || queryFlag"
    :rules="rules"
    :class="dynamicClass({ type: 'memo', customStyle, queryFlag })"
    :style="dynamicStyle({ customStyle })"
    :rows="1"
    :outlined="queryFlag"
    :hide-details="queryFlag"
    :dense="queryFlag"
    :maxLength="maxLength()"
    :minLength="minLength()"
    @input="() => handleChange(null)"
  />
</template>

<script>
export default {
  name: "MemoField",
  props: [
    "label",
    "value",
    "access",
    "pattern",
    "id",
    "name",
    "prefix",
    "suffix",
    "rules",
    "dataType",
    "queryFlag",
    "customStyle",
    "coordinates",
    "length",
    "secLength",
  ],
  data() {
    return {
      defaultValue: this.value,
      currentValue: this.value
    };
  },
  methods: {
    handleChange(autoSource) {
      const data = {
        value: this.currentValue,
        id: this.id,
        autoSource, //: this.autoSource,
        coordinates: this.coordinates
      };
      this.$emit("field-change", data);
    },
    setValue(value, autoSource) {
      this.currentValue = value;
      //this.autoSource = autoSource;
      this.handleChange(autoSource);
    },
    maxLength() {
      let result = this.length;
      return result;
    },
    minLength() {
      return !this.fieldTextType(this.dataType) != "number"
        ? this.secLength
        : null;
    },
  },
};
</script>

<style scoped>
.custom-memo-style >>> .v-text-field__slot label {
  color: var(--label-color);
  background-color: var(--label-background-color);
  font-size: var(--label-size);
  border: var(--label-border);
  border-radius: var(--label-border-radius);
}
.custom-memo-style >>> .v-text-field__slot textarea {
  color: var(--input-color);
  background-color: var(--input-background-color);
  font-size: var(--input-size);
  border: var(--input-border);
  border-radius: var(--input-border-radius);
}
.custom-memo-style >>> .v-text-field__slot .v-text-field__prefix {
  color: var(--prefix-color);
  background-color: var(--prefix-background-color);
  font-size: var(--prefix-size);
  border: var(--prefix-border);
  border-radius: var(--prefix-border-radius);
}
.custom-memo-style >>> .v-text-field__slot {
  color: var(--slot-color);
  background-color: var(--slot-background-color);
  font-size: var(--slot-size);
  padding: var(--slot-padding);
  margin: var(--slot-margin);
  border: var(--slot-border);
  border-radius: var(--slot-border-radius);
}

.custom-memo-style {
  color: var(--field-color);
  background-color: var(--field-background-color);
  font-size: var(--field-size);
  padding: var(--field-padding);
  margin: var(--field-margin);
  border: var(--field-border);
  border-radius: var(--field-border-radius);
}
</style>